<template>
  <component :is="layoutComponent">
    <div v-if="media && authorizedUser">
      <div v-if="this.$route.name =='network_media'" class="d-none d-xxl-block" style="margin-top: 115px;"></div>
      <div v-if="!hide_media_detail">
        <div class="row mb-n4">
          <div class="navbar navbar-expand-lg">
            <!-- Breadcrumbs -->
            <div class="col-10">
              <nav aria-label="breadcrumb">
                <ol v-if="!busy" class="pt-1 breadcrumb align-middle">
                  <li class="breadcrumb-item">
                    <a :href="network ? '/networks/' + network.slug : '/media'" class="text-primary fw-bold">
                      {{ slug ? network.name : $t('network.AllMedia') }}
                    </a>
                  </li>
                  <li v-if="network" class="breadcrumb-item">
                    <a :href="'/networks/' + network.slug + '/media'" class="text-primary fw-bold">
                      {{ $t('nav.media') }}
                    </a>
                  </li>
                </ol>
              </nav>
            </div>
            <div class="toolbar d-flex justify-content-end order-lg-3 ms-lg-auto col-2">
              <a v-if="media.type === 'file' && media.can_download" id="download_media" data-test="download_media"
              class="text-primary fw-bold pointer text-decoration-none" style="padding: 0.425rem 0.5rem !important" @click="downloadMedia()">
                <i class="fa fa-download"></i>&nbsp;
                {{ $t('network.download') }}
              </a>
              <div class="navbar-tool dropdown">
                <a href="#" class="navbar-tool-label dropdown-toggle border rounded-3 border-0 user-dropdown ms-4 me-2 d-flex"
                data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fa-solid fa-ellipsis-vertical fs-3"></i>
                </a>
                <ul class="dropdown-menu dropdown-menu-end pointer" style="top: 100%;">
                  <li>
                    <Fav :loading="loading" :media="true" :value="is_liked" @input="toggleLike" />
                  </li>
                  <li>
                    <a class="dropdown-item d-flex align-items-center text-decoration-none" @click="showShareModal = !showShareModal">
                      <i class="fas fa-share text-primary"></i>&nbsp;
                      {{ $t('share') }}
                    </a>
                  </li>
                  <li v-if="media.can.update">
                    <router-link :to="{ path: $route.path + '/edit', params: { network: network } }"
                    class="dropdown-item d-flex align-items-center text-decoration-none">
                      <i class="fas fa-edit text-primary"></i>&nbsp;
                      {{ $t('edit') }}
                    </router-link>
                  </li>
                  <li v-if="media.can.delete">
                    <a class="dropdown-item d-flex align-items-center text-decoration-none" @click="showDeleteModal = !showDeleteModal">
                      <i class="fas fa-trash text-danger"></i>&nbsp;
                      {{ $t('network.delete') }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-items-center" style="margin-top: 18px;">
            <h4 class="text-secondary ms-2">{{ media.title }}</h4>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-items-center border-left fw-semibold">
            <div v-if="media.presenters.length > 1" class="d-flex mt-2 align-items-center">
              <div class="mx-3">
                <div class="avatar-group avatar-group-overlapped mr-40 mt-25">
                  <div v-for="(p, i) in media.presenters.slice(0, 2)" :key="'presenter-' + i" class="avatar">
                    <img :src="p.image" :alt="p.name" class="avatar-img rounded-circle" />
                  </div>
                  <div v-if="media.presenters.length > 2" class="avatar">
                    <span class="avatar-text avatar-text-indigo rounded-circle">
                      <span class="initial-wrap">
                        <span>+{{ parseInt(media.presenters.length - 2) }}</span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="mx-3 text-start dropdown">
                <a
                  v-if="media.presenters.length > 0"
                  :id="'anchor'"
                  ref="anchor"
                  href="javascript:void(0)"
                  aria-describedby="tooltip"
                  class="dropbtn text-secondary"
                  style="text-decoration: none;"
                  @click="visitMedia(media)"
                  @mouseenter="reinitilizePopper()"
                >
                  <span class="presenter-facepile-text">{{ $t('CardFull.presented-by') }}</span>
                  <span class="presenter-facepile-text">
                    <span v-for="(p, i) in media.presenters.slice(0, 3)" :key="'presenter-text-' + i" :class="i > 0 ? 'ms-1' : ''">
                      {{ p.name }}<span v-if="media.presenters.length-1 != i">, </span>
                    </span>
                  </span>
                  <span v-if="media.presenters.length > 3" class="presenter-facepile-text">
                    {{ $t('and-others', { num: parseInt(media.presenters.length - 3) }) }}
                  </span>
                </a>
                <ul :id="'anchordropdown'" ref="anchordropdown" class="list-group dropdown-content">
                  <li v-for="(p, i) in media.presenters.slice(0, media.presenters.length)" :key="'presenter-' + i" class="list-group-item">
                    <span class="pull-left ms">
                      <div :key="'presenter-' + i" class="avatar avatar-small">
                        <img :src="p.image" :alt="p.name" height="35" width="35" class="avatar-img rounded-circle" />
                      </div>
                    </span>
                    {{ p.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="media.presenters.length === 1" class="d-flex g-0 align-items-center" style="min-height: 42px;">
              <div class="mx-3">
                <div class="avatar-group avatar-group-overlapped mr-40 mt-25">
                  <div v-for="(p, i) in media.presenters.slice(0, 1)" :key="'presenter-' + i" class="avatar">
                    <img :src="p.image" :alt="p.name" class="avatar-img rounded-circle" />
                  </div>
                </div>
              </div>
              <div class="mx-3 text-start mt-1">
                <span v-for="(p, i) in media.presenters.slice(0, 1)" :key="'presenter-text-' + i" href="javascript:void(0)">
                  <p class="presenter-facepile-text">{{ $t('CardFull.presented-by') }} {{ p.name }}</p>
                </span>
              </div>
            </div>
            <div v-if="media.presenters.length === 0 && media.created_by" class="d-flex g-0 align-items-center" style="min-height: 42px;">
              <div class="mx-3">
                <div class="avatar-group avatar-group-overlapped mr-40 mt-25">
                  <div class="avatar">
                    <img :src="media.creator_img ? media.creator_img : '/img/user.png'" class="avatar-img rounded-circle" />
                  </div>
                </div>
              </div>
              <div class="mx-3 text-start mt-1">
                <p class="presenter-facepile-text">{{ $t('created-by') }} {{ media.created_by }}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-items-center border-left">
            <div style="display: flex; justify-content: space-evenly;">
              <span class="ms-2 mt-3">
                <i class="fas fa-calendar-day"></i>&nbsp;
                <strong v-if="media.publish_date">{{ formatDate(media.publish_date) }}</strong>
                <strong v-else>{{ $t('not-available') }}</strong>
              </span>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div v-else>
        <div class="row">
          <div class="col text-lg-start">
            <h2 class="text-secondary display-8 mb-0 pe-2" style="display: inline-block;">{{ media.title }}</h2>
            <button v-if="media.type === 'file' && collection.can_download" id="show_download_modal" data-test="show_download_modal" class="btn btn-outline-primary rounded-circle"
            style="border: 2px solid; padding: 1px 6px; vertical-align: bottom;" @click="downloadMedia()">
              <i class="fa fa-download"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="busy" class="text-center pt-7">
      <lottie-player
        autoplay
        loop
	      speed="2.5"
        src="/img/animations/custom_loader.json"
        style="height: 130px;"
        >
      </lottie-player>
      <p id="cancel-label">{{ $t('network.fetchingMediaDetails') }}</p>
    </div>

    <div v-if="media && authorizedUser" class="row my-3">
      <MediaSection :collection="collection" :inCollection="hide_media_detail" :media="media" />
    </div>

    <b-modal v-if="media && media.networks" v-model="showDeleteModal" hide-footer hide-header size="lg">
      <label for="" class="pb-1 fw-bold opacity-80">
        <span v-if="media.networks.length == 1">{{ $t('following-media-is-available-in-1-network') }}</span>
        <span v-else>{{ $t('following-media-is-available-in-networks-choose-the-ones-from-which-you-wish-to-delete-it', { num: media.networks.length }) }}</span>
      </label>
      <ul class="list-group rounded-0">
        <li v-for="(mediaNetwork,index) in media.networks" :key="index" class="list-group-item text-primary"> 
          <div class="row">
            <div class="col-10 ps-0">{{ mediaNetwork.name }} </div>
            <div class="col-2 text-end p-0" role="button" @click="removeNetwork(mediaNetwork)"><i class="fa fa-close text-danger"></i></div>
          </div>
        </li>
      </ul>
    </b-modal>
    <b-modal v-model="showShareModal" hide-footer hide-header no-stacking>
      <div class="text-center">
        <span>{{ $t('share-this-media-to-your-choice-of-social-media-or-contacts') }}</span><br /><br />
        <a class="pointer" @click="accessShareLink('Facebook', facebook+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 20px;" xml:space="preserve">
            <path style="fill:#475993;" d="M353.701,0H55.087C24.665,0,0.002,24.662,0.002,55.085v298.616c0,30.423,24.662,55.085,55.085,55.085
            h147.275l0.251-146.078h-37.951c-4.932,0-8.935-3.988-8.954-8.92l-0.182-47.087c-0.019-4.959,3.996-8.989,8.955-8.989h37.882
            v-45.498c0-52.8,32.247-81.55,79.348-81.55h38.65c4.945,0,8.955,4.009,8.955,8.955v39.704c0,4.944-4.007,8.952-8.95,8.955
            l-23.719,0.011c-25.615,0-30.575,12.172-30.575,30.035v39.389h56.285c5.363,0,9.524,4.683,8.892,10.009l-5.581,47.087
            c-0.534,4.506-4.355,7.901-8.892,7.901h-50.453l-0.251,146.078h87.631c30.422,0,55.084-24.662,55.084-55.084V55.085
            C408.786,24.662,384.124,0,353.701,0z"/>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('WhatsApp', whatsapp+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 20px;" xml:space="preserve">
            <path style="fill:#7AD06D;" d="M198.929,0.242C88.5,5.5,1.356,97.466,1.691,208.02c0.102,33.672,8.231,65.454,22.571,93.536
              L2.245,408.429c-1.191,5.781,4.023,10.843,9.766,9.483l104.723-24.811c26.905,13.402,57.125,21.143,89.108,21.631
              c112.869,1.724,206.982-87.897,210.5-200.724C420.113,93.065,320.295-5.538,198.929,0.242z M323.886,322.197
              c-30.669,30.669-71.446,47.559-114.818,47.559c-25.396,0-49.71-5.698-72.269-16.935l-14.584-7.265l-64.206,15.212l13.515-65.607
              l-7.185-14.07c-11.711-22.935-17.649-47.736-17.649-73.713c0-43.373,16.89-84.149,47.559-114.819
              c30.395-30.395,71.837-47.56,114.822-47.56C252.443,45,293.218,61.89,323.887,92.558c30.669,30.669,47.559,71.445,47.56,114.817
              C371.446,250.361,354.281,291.803,323.886,322.197z"/>
            <path style="fill:#7AD06D;" d="M309.712,252.351l-40.169-11.534c-5.281-1.516-10.968-0.018-14.816,3.903l-9.823,10.008
              c-4.142,4.22-10.427,5.576-15.909,3.358c-19.002-7.69-58.974-43.23-69.182-61.007c-2.945-5.128-2.458-11.539,1.158-16.218
              l8.576-11.095c3.36-4.347,4.069-10.185,1.847-15.21l-16.9-38.223c-4.048-9.155-15.747-11.82-23.39-5.356
              c-11.211,9.482-24.513,23.891-26.13,39.854c-2.851,28.144,9.219,63.622,54.862,106.222c52.73,49.215,94.956,55.717,122.449,49.057
              c15.594-3.777,28.056-18.919,35.921-31.317C323.568,266.34,319.334,255.114,309.712,252.351z"/>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('LinkedIn', linkedin+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 10px;" xml:space="preserve">
            <path style="fill:#0077B7;" d="M347.445,0H34.555C15.471,0,0,15.471,0,34.555v312.889C0,366.529,15.471,382,34.555,382h312.889
            C366.529,382,382,366.529,382,347.444V34.555C382,15.471,366.529,0,347.445,0z M118.207,329.844c0,5.554-4.502,10.056-10.056,10.056
            H65.345c-5.554,0-10.056-4.502-10.056-10.056V150.403c0-5.554,4.502-10.056,10.056-10.056h42.806
            c5.554,0,10.056,4.502,10.056,10.056V329.844z M86.748,123.432c-22.459,0-40.666-18.207-40.666-40.666S64.289,42.1,86.748,42.1
            s40.666,18.207,40.666,40.666S109.208,123.432,86.748,123.432z M341.91,330.654c0,5.106-4.14,9.246-9.246,9.246H286.73
            c-5.106,0-9.246-4.14-9.246-9.246v-84.168c0-12.556,3.683-55.021-32.813-55.021c-28.309,0-34.051,29.066-35.204,42.11v97.079
            c0,5.106-4.139,9.246-9.246,9.246h-44.426c-5.106,0-9.246-4.14-9.246-9.246V149.593c0-5.106,4.14-9.246,9.246-9.246h44.426
            c5.106,0,9.246,4.14,9.246,9.246v15.655c10.497-15.753,26.097-27.912,59.312-27.912c73.552,0,73.131,68.716,73.131,106.472
            L341.91,330.654L341.91,330.654z"/>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('Twitter', twitter+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="55" height="55" viewBox="0 0 1668.56 1221.19" style="enable-background:new 0 0 1668.56 1221.19; margin-right: 10px;" xml:space="preserve">
          <g id="layer1" transform="translate(52.390088,-25.058597)">
            <path id="path1009" d="M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99
              h-87.51l-313.51,338.7l-253.31-338.7H283.94z M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z"/>
          </g>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('Email', email+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 128 128" style="enable-background:new 0 0 128 128;" xml:space="preserve">
            <circle style="fill:#267CB5;" cx="64" cy="64" r="64"/>
            <path style="fill:#FFFFFF;" d="M64,28"/>
            <path style="fill:#FFFFFF;" d="M64,72.4l38.2-32.7c-0.6-0.4-1.4-0.7-2.2-0.7H28c-0.8,0-1.6,0.3-2.2,0.7L64,72.4z"/>
            <path style="fill:#FFFFFF;" d="M66.6,75.4c-1.5,1.3-3.7,1.3-5.2,0L24,43.5V85c0,2.2,1.8,4,4,4h72c2.2,0,4-1.8,4-4V43.4L66.6,75.4z"/>
          </svg>
        </a>
      </div>
      <div class="form-control align-items-center sharing">
        <span class="url-field">{{ home + '/...' }}</span>
        <div style="float: right;">
          <span class="btn btn-primary btn-sm text-white copy-btn" @click.prevent="copyUrl">
            <span style="text-transform: capitalize; margin-bottom: -1px;">{{ $t('Invite.copy') }}</span>
          </span>
        </div>
        <input id="url" data-test="url" :value="home+viewUrl" type="hidden">
      </div>
      <span id="copied">{{ $t('Invite.copied') }}</span>
    </b-modal>
    <b-modal v-model="showAdBlockModal" hide-footer hide-header>
      <div>
        <div style="padding: 10px 0; float: left; width: 100%;">
          <img src="@/assets/img/networks-logo.png" alt="logo" style="float: left; width: 180px; margin-bottom: 20px;" />
        </div>
        <h2 class="mb-4 text-secondary">
          It looks like you are using <br /> an ad blocker!
        </h2>
        <p class="fw-semibold text-secondary mb-2">
          We use Vimeo to share video content with you, and for it to work correctly your ad blocker needs to be disabled.
        </p>
      </div>
    </b-modal>
    <b-modal id="show-private-media-modal" v-model="showPrivateMediaModal" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
      <span class="fs-3 pointer pe-0" style="float: right;" @click="$bvModal.hide('show-private-media-modal')"><i class="fa-solid fa-xmark"></i></span>
      <div class="text-center py-4">
        <h5 class="text-secondary m-4">
          You're not authorized to see this content. If you have any questions, please contact the support team.
        </h5>
        <button id="contact_support" data-test="contact_support" class="btn btn-primary" style="padding: 8px 32px;" @click="contactNow">
          {{ $t('contact-support') }}
        </button>
      </div>
    </b-modal>

    <JoinNetworkCard :show="showJoinCard" :network="network" :instance="instance" />
  </component>
</template>
<script>
import { DeleteMediaMixin } from '@/mixins/NetworkMedia/DeleteMediaMixin.js';
// import BadgeList from '@/components/commons/Networks/BadgeList.vue';
import JoinNetworkCard from '@/components/commons/Networks/JoinNetworkCard.vue';
import MediaSection from '@/components/commons/Media/Section.vue';
import Fav from '@/components/Fav.vue';
import { createPopper } from '@popperjs/core';
import { durationForHumans } from '@/lib/util.js';
import moment from 'moment';
import split from 'lodash/split';
import { detectAnyAdblocker } from 'just-detect-adblock'
import { mapState } from 'vuex';

export default {
  name: 'MediaShow',
  components: {
    JoinNetworkCard,
    MediaSection,
    Fav,
  },
  mixins: [DeleteMediaMixin],
  props: {
    slug: {
      type: String,
      default: null,
    },
    media_slug: {
      type: String,
      default: null,
    },
    hide_media_detail: {
      type: Boolean,
      default: false,
    },
    collection: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busy: true,
      loading: false,
      media: null,
      windowHeight: window.innerHeight,
      popper: {},
      network: null,
      authorizedUser: false,
      showDeleteModal: false,
      home: window.location.origin,
      facebook: 'https://www.facebook.com/share.php?u=',
      whatsapp: 'https://wa.me/?text=',
      linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=',
      twitter: 'https://twitter.com/share?ref_src=twsrc%5Etfw&url=',
      email: 'mailto:?subject=Resonance media&amp;body=Check out this media ',
      showShareModal: false,
      is_liked: '',
      showAdBlockModal: false,
      showPrivateMediaModal: false,
      showJoinCard: false,
      instance: '',
    };
  },
  computed: {
    ...mapState('network', ['myNetworks']),
    layoutComponent() {
      let path = split(this.$route.fullPath, '/');
      if (this.slug || path[2] == 'collections' || path[3] == 'collections') {
        return 'NoLayout';
      }
      return 'DefaultLayout';
    },
    fileExtension() {
      if (this.media.type === 'file' && this.media.url) {
        var url = new URL(this.media.url.download);
        var file = url.pathname.toLowerCase();
        // get the extension
        return file.split('.').pop();
      }
      return 'vimeo';
    },
    // compute the height of the PDF embed
    heightForPDF() {
      var newHeight = 500;
      if (this.windowHeight) {
        newHeight = this.windowHeight - 320; // 220 is the height taken up by the header and some of that by the footer
        if (newHeight < 200) newHeight = 200;
      }
      return newHeight;
    },
    viewUrl() {
      let url = this.network ? '/networks/' + this.network.slug + '/' : '/';
      url += this.media ? 'media/' + this.media.slug : '';
      return url;
    },
  },
  watch: {
    media_slug(newV) {
      if (this.media) {
        if (newV !== this.media.slug) this.refresh();
      }
    },
    showJoinCard(newVal) {
      if (newVal == true) {
        this.$store.dispatch('setNextURL', this.$route.fullPath);
      }
    },
  },
  mounted() {
    this.refresh();
    this.initPoppers();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    detectAdblocker() {
      detectAnyAdblocker().then((detected) => {
        if(detected){
          // an adblocker is detected
          this.showAdBlockModal = true;
        }
      });
    },
    initPoppers() {
      // TODO: destroy any registered poppers
      let anchorEl = this.$refs.anchor;
      let anchordropdownEl = this.$refs.anchordropdown;
      if (anchorEl && anchordropdownEl) {
        // initialize poppers
        this.popper = createPopper(anchorEl, anchordropdownEl, {
          placement: 'auto',
        });
      }
    },
    reinitilizePopper() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.popper.update();
        }, 100);
      });
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    formatDate(date) {
      return moment.parseZone(date).format('MM-DD-YYYY');
    },
    durationForHumans(seconds) {
      return durationForHumans(seconds);
    },
    contactNow() {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track('open-support-modal');
      }
      this.$bus.emit('show-support-form');
    },
    deleteMediaResource(url, network = null) {
      this.deleteMedia(url).then(() => {
        if (network) {
          this.$router.push({
            name: 'network-page',
            params: { slug: network.slug },
          });
        } else {
          this.$router.push('/networks');
        }
      });
    },
    // check the route parameter and the store, and refresh it if needed
    refresh() {
      if (this.media == null || this.media.slug !== this.media_slug) {
        // refresh it!
        this.busy = true;
        this.$http.get('networks/media/' + this.media_slug).then(resp => {
          this.media = resp.data;
          this.is_liked = resp.data.is_liked;
          this.busy = false;

          if (this.media.type === 'file') {
            var height = this.windowHeight;
            height += 1;
            height;
          } else {
            this.detectAdblocker();
          }
          // load network data if needed
          if (this.slug !== null && this.network === null) {
            this.busy = true;
            this.$http.get('networks/' + this.slug).then(resp => {
              this.network = resp.data;
              this.busy = false;

              // now that network data is loaded, call visitMedia
              if (this.media !== null) {
                this.visitMedia(this.media);
              }
            });
          } else {
            // no network
            if (this.media !== null) {
              this.visitMedia(this.media);
            }
          }
        }).catch(error => {
          // Check for 404 status manually and handle it
          if (error && error.status === 404) {
            // The resource was not found (invalid media_slug)
            this.$router.push('/404');
          } else {
            // Other server response errors or network issues
            console.log('Error:', error.message);
          }
        });
      }
    },
    accessShareLink(link_name, link) {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track(`share-media-${link_name.toLowerCase()}-${this.media.id}`);
      }
      let url = 'media/' + this.media.slug + '/' + this.$store.getters['user']['user_id'] + '/' + link_name;
      this.$http.post(url).then(() => {
        window.location.href = link;
      });
    },
    resetVimeoMeta(slug) {
      let msg = this.$t('network.updateVimeoMetadataAlert') + '?';
      let action = () => {
        this.$http.post('networks/media/' + slug + '/vimeo-fetch');
      };
      this.showConfirmPrompt(action, msg);
    },
    visitMedia(media) {
      if (this.$auth.auth) {
        if (media.permission == 'public' || media.permission == 'unlisted' || (this.network && this.network.is_mine) || this.$auth.hasRole('super-admin')) {
          this.authorizedUser = true;
        } else {
          if (this.network) {
            if (this.network.public) {
              if (this.network.moderation) {
                // public and moderated network
                if (this.network.industry_membership_expired) {
                  // for user whose membership has expired
                  this.instance = 'showIndustryMembershipExpiredModal';
                  this.showJoinCard = true;
                } else if (this.network.is_in_moderation_queue) {
                  // for users who have applied to join the moderated network
                  if (this.network.join_status != 'REJECTED') {
                    // for users who have applied to join the moderated network (pending status)
                    this.instance = 'showPendingModerationModalFromMedia';
                    this.showJoinCard = true;
                  } else if (this.network.join_status == 'REJECTED') {
                    // for users who have applied to join the moderated network (rejected status)
                    this.instance = 'showRejectedModerationModalFromMedia';
                    this.showJoinCard = true;
                  }
                } else if (this.network.is_in_industry_moderation_queue) {
                  // for industry users who have applied to join the moderated network
                  if (this.network.industry_join_status != 'REJECTED') {
                    // for industry users who have applied to join the moderated network (pending status)
                    this.instance = 'showIndustryPendingModerationModal';
                    this.showJoinCard = true;
                  } else if (this.network.industry_join_status == 'REJECTED') {
                    // for industry users who have applied to join the moderated network (rejected status)
                    this.instance = 'showIndustryRejectedModerationModal';
                    this.showJoinCard = true;
                  }
                } else {
                  // public and non moderated network - for users who haven't applied to join
                  this.instance = 'showModerationModalFromMedia';
                  this.showJoinCard = true;
                }
              } else {
                // public and non moderated network
                this.instance = 'showPublicJoinModalFromMedia';
                this.showJoinCard = true;
              }
            } else {
              // private network
              this.instance = 'showPrivateModalFromMedia';
              this.showJoinCard = true;
            }
          } else {
            this.authorizedMedia(media);
          }
        }
      } else {
        // logged out
        if (media.permission == 'public' || media.permission == 'unlisted') {
          this.authorizedUser = true;
        } else {
          if (this.network) {
            // media within network
            this.instance = 'showLoggedOutModal';
            this.showJoinCard = true;
          } else {
            // media in all media
            this.$bus.emit('show-sign-in', media.url.view, this.$t('auth.signInMessage.protectedMedia'));
          }
        }
      }
    },
    removeNetwork(network){
      if (this.media.networks.length == 1) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('deleting-this-file-will-remove-it-from-networks-contact-support-if-you-wish-to-restore-it-at-a-later-period-of-time-or-felt-that-you-made-a-mistake'),
          showCancelButton: true,
          confirmButtonText : this.$t('network.delete'),
          customClass: {
            confirmButton: 'btn btn-danger mx-1',
            cancelButton: 'btn btn-primary mx-1',
          },
          buttonsStyling: false
        }).then( (result) => {
          if(result.isConfirmed){
            this.$swal.fire({
              icon: 'success',
              title: this.$t('success'),
            }).then(() => {
              this.$http.delete('networks/media/' + this.media.slug).then(() => {
                let path = split(this.$route.fullPath, '/');
                if (path[1] == 'media') {
                  this.$router.push('/media');
                } else {
                  this.$router.push('/networks/' + path[2] + '/media');
                }
              });
            });
          }
        });
      } else {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('are-you-sure-about-this'),
          showCancelButton: true,
          confirmButtonText : this.$t('yes-remove'),
          customClass: {
            confirmButton: 'btn btn-danger mx-1',
            cancelButton: 'btn btn-primary mx-1',
          },
          buttonsStyling: false
        }).then((result) => {
          if(result.isConfirmed){
            this.$http.post('networks/media/network/remove', { network : network, network_media_id : this.media.id }).then(resp => {
              if(resp){
                this.media.networks.splice(this.media.networks.indexOf(network), 1);
              }
            });
          }
        });
      }
    },
    downloadMedia() {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track(`download-media-${this.media.id}`);
      }
      this.$http.post('log-activity/' + this.media.slug, { action: 'download' }).then(() => {
        window.location.href = this.media.url.download;
      });
    },
    toggleLike() {
      this.loading = true;
      this.$http.post('networks/media/' + this.media.slug + '/toggle-like').then(resp => {
        if (resp.data == 1) {
          this.is_liked = false;
          // umami tracking for unlike action
          if (window.umami && typeof window.umami.track === 'function') {
            window.umami.track(`unlike-media-${this.media.id}`);
          }
          this.$swal.fire({
            text: this.$t('removed-from-your-liked-media'),
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          this.loading = false;
        } else {
          this.is_liked = true;
          // umami tracking for like action
          if (window.umami && typeof window.umami.track === 'function') {
            window.umami.track(`like-media-${this.media.id}`);
          }
          this.$swal.fire({
            text: this.$t('added-to-your-liked-media'),
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          this.loading = false;
        }
      });
    },
    copyUrl () {
      let urlToCopy = document.querySelector('#url')
      urlToCopy.setAttribute('type', 'text')
      urlToCopy.select()

      document.getElementById("copied").style.display = "inline";
      document.execCommand("copy");
      setTimeout( function() {
          document.getElementById("copied").style.display = "none";
      }, 1000);

      /* unselect the range */
      urlToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    arraysMatch(arr1, arr2) {
      // function to compare two arrays for equality
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    },
    authorizedMedia(media) {
      let foundMatch = false;
      for (let i = 0; i < media.networks.length; i++) {
        for (let j = 0; j < this.myNetworks.length; j++) {
          if (this.arraysMatch(media.networks[i], this.myNetworks[j])) {
            // if there's a match, set authorizedUser to true
            foundMatch = true;
            // exit the inner loop
            break;
          }
        }
        if (foundMatch) {
          // exit the outer loop if a match is found
          break;
        }
      }
      if (foundMatch) {
        this.authorizedUser = true;
      } else {
        this.showPrivateMediaModal = true;
      }
    },
  },
};
</script>
<style>
.swal2-timer-progress-bar {
  background-color: #198754;
}
.sharing {
  margin-top: 28px;
  background: #D9D9D9;
  padding-right: 9px;
}
.url-field {
  line-height: 24px;
  font-weight: 400;
  text-align: left;
  color: #005F9A;
  font-size: 15px;
  user-select: none;
}
.copy-btn {
  display: flex;
  padding: 5px 20px;
}
.copy-btn span {
  font-size: 10px;
  font-weight: 400;
}
#copied {
  font-size: 14px;
  color: red;
  display: none;
}
</style>